import { render, staticRenderFns } from "./Standardevent.vue?vue&type=template&id=ca6f5f22"
import script from "./Standardevent.vue?vue&type=script&lang=js"
export * from "./Standardevent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports